(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const images = Array.from(document.querySelectorAll('.perfumer-profile__media .perfumer-profile__image'));
  if (!images.length) return;

  const speed = 0.08;
  const maxOffset = 20;
  let ticking = false;

  function update() {
    const viewportCenter = window.innerHeight / 2;

    images.forEach((image) => {
      if (image.offsetParent === null) return;

      const rect = image.getBoundingClientRect();
      const elementCenter = rect.top + rect.height / 2;
      const delta = viewportCenter - elementCenter;
      const offset = Math.max(-maxOffset, Math.min(maxOffset, delta * speed));

      image.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
    });

    ticking = false;
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  document.addEventListener('shopify:section:load', requestTick);
  document.addEventListener('shopify:section:reorder', requestTick);

  requestTick();
})();
